function find(ev, data)
{
    if (typeof ev.target.dataset[data] !== "undefined")
    {
        return ev.target.dataset[data];
    }
}
module.exports ={
   find
}